import React from 'react';
import { Typography } from '@material-ui/core';

function OxygenCompletenessCheck() {
  return (
    <div>
      <Typography variant="h5">
        Oxygen Completeness Check page is coming soon.
      </Typography>
    </div>
  );
}

export default OxygenCompletenessCheck;
